class FavoriteList extends HTMLElement {
  constructor() {
    super();
    this.cards = this.querySelectorAll('favorite-card');

    this.container = this.querySelector('.favorite-list');
    this.button = this.querySelector('.remove-favorite-button');
    this.app_url = this.getAttribute('data-app-url');
    this.cutomer_id = this.getAttribute('data-customer-id');
    this.store_domain = this.getAttribute('data-store-domain');
    this.locale = this.getAttribute('data-locale');

    this.init();
  }
  init() {
    this.cards.forEach((card) => {
      var sku = card.dataset.sku;

      fetch(
        `${window.routes.search_url}?q=${sku}&page=1&types=sku&section_id=component_favorite-card`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          let card_data = html.querySelector('.favorite-product-card');
          if (card_data) {
            let available = card_data.getAttribute('data-available');
            if (available != null && available != 'null') {
              card.append(card_data);
            } else {
              card.remove();
            }
          }
        });
    });
  }

  updateList() {
    fetch('/pages/favorites')
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`favorite-list`);
        const source = html.getElementById(`favorite-list`);
        destination.innerHTML = source.innerHTML;
      });
  }
}

customElements.define('favorite-list', FavoriteList);

class FavoriteRemove extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.remove-favorite-button');
    this.app_url = this.dataset.appUrl;
    this.customer_id = this.dataset.customerId;
    this.store_domain = this.dataset.storeDomain;
    this.part_number = this.dataset.partNumber;
    this.button.addEventListener('click', this.removeFavorite.bind(this));
  }

  removeFavorite() {
    fetch(`${this.app_url}/customers/${this.customer_id}/favorites`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify({
        store: this.store_domain,
        partnumber: this.part_number,
      }),
    }).then((response) => {
      if (response.ok) {
        this.closest('favorite-card').remove();
      }
    });
  }
}

customElements.define('favorite-remove', FavoriteRemove);
